import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal, H2, Image, Button, Typography } from './index';
import { ROUTES } from '../Constants';
import { getSpacing } from '../utils';
import PalmIllustration from '../assets/images/illustrations/palm.svg';

const ImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 160px;
  justify-content: center;
  width: 100%;
  margin-bottom: ${getSpacing('large')};
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-bottom: ${getSpacing('large')};
`;

const SessionIdleModal = ({ history }) => (
  <Modal closeButton={false} padding={{ top: 'large', right: 'small', left: 'small' }}>
    <H2 fontWeight={700} margin={{ bottom: 'xs' }}>
      Your Session Was Idle for Too Long
    </H2>
    <Typography margin={{ bottom: 'large' }}>
      The task was automatically submitted to prevent loss of work.
      <br />
      Thanks for checking!
    </Typography>

    <ImageContainer>
      <Image src={PalmIllustration} />
    </ImageContainer>

    <ButtonContainer>
      <Button
        onClick={async () => {
          history.push(ROUTES.HOME);
        }}
      >
        Go to dashboard
      </Button>
    </ButtonContainer>
  </Modal>
);

SessionIdleModal.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

export { SessionIdleModal };
